import React, { useEffect } from 'react';

import { useAuth } from '../lib/frontend/auth';
import { createQueryString } from '../lib/universal/util';
import Spinner from './Spinner';

const AuthPage: React.FC = ({ children }) => {
  const { profile, isForbidden, isLoading, isLoggedIn } = useAuth();

  useEffect(() => {
    if (profile === null) {
      window.location.href = `/api/auth/login?${createQueryString({
        redirectTo: window.location.pathname + window.location.search,
      })}`;
    }
  }, [profile]);

  useEffect(() => {
    if (isForbidden) {
      window.location.href = '/forbidden';
    }
  }, [isForbidden]);

  return isLoading && profile === undefined ? (
    <Spinner />
  ) : isLoggedIn ? (
    <>{children}</>
  ) : (
    <div />
  );
};

export default AuthPage;
